import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useNavigationHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Simple scroll to top on route change
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return { navigate };
}; 